import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiList } from './apiList.service';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { driverListResponse, tripsResponse } from '../models/trip.model';
import { CommonResponse } from '../models/common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TripsService {
  constructor(
    private http: HttpClient,
    private _apiList: apiList
  ) {}

  getTrips(query: string): Observable<tripsResponse> {
    const url = `${environment.base_url}${this._apiList.trips}?${query}`;

    return this.http.get<{ data: tripsResponse }>(url).pipe(
      tap(res => console.log('Trips API raw response:', res)),
      map(res => {
        // Defensive check to prevent runtime errors
        return res?.data ?? { list: [], total: 0 };
      }),
      catchError(err => {
        console.error('Trips API error:', err);
        // Fallback to avoid breaking app
        return of({ list: [], total: 0 });
      })
    );
  }

  getDrivers(query: string, id: number): Observable<driverListResponse> {
    return this.http
      .get<{
        data: driverListResponse;
      }>(
        `${environment.base_url}${this._apiList.customerPosition}/${id}?${query}`
      )
      .pipe(map(res => res.data));
  }

  assignDriver(
    payload: { driver_id: number },
    id: number
  ): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(
        `${environment.base_url}${this._apiList.tripAssignDriver}/${id}`,
        payload
      )
      .pipe(map(res => res.data));
  }

  driverAcceptReject(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any,
    id: number
  ): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(
        `${environment.base_url}${this._apiList.DriverTripAccept}/${id}`,
        payload
      )
      .pipe(map(res => res.data));
  }

  tripStatus(
    payload: { status: string },
    id: number
  ): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(`${environment.base_url}${this._apiList.tripStatus}/${id}`, payload)
      .pipe(map(res => res.data));
  }

  tripStatusCancel(
    payload: { status: string; reason_id: number },
    id: number
  ): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(`${environment.base_url}${this._apiList.tripStatus}/${id}`, payload)
      .pipe(map(res => res.data));
  }

  completeLocation(
    payload: { is_completed: boolean },
    id: number
  ): Observable<CommonResponse> {
    return this.http
      .patch<{
        data: CommonResponse;
      }>(`${environment.base_url}${this._apiList.tripLocation}/${id}`, payload)
      .pipe(map(res => res.data));
  }
}
